<template>
  <!-- Manuelle Anpassung mobil; mit inventurModus = Inventur: Protokolltyp fest "Zaehlung",
       Grund vorbelegt "gezaehlt" (Trello 21.08.) -->
  <div class="m-wms-form">
    <div class="m-wms-form__field">
      <label>{{ $t("mobile.wms.historyType") }} *</label>
      <input v-if="inventurModus" :value="typeLabel('Counting')" readonly />
      <select v-else v-model="historyType">
        <option v-for="t in historyTypes" :key="t" :value="t">{{ typeLabel(t) }}</option>
      </select>
    </div>

    <div class="m-wms-form__field">
      <label>{{ $t("mobile.wms.reason") }} *</label>
      <input v-model="reason" :placeholder="$t('mobile.wms.reasonPlaceholder')" />
    </div>

    <m-wms-inventory-picker v-model="entry" />

    <div class="m-wms-form__field" @click="numPadOpen = true">
      <label>{{ $t("mobile.wms.quantity") }} *</label>
      <input :value="quantity || ''" readonly :placeholder="$t('mobile.wms.quantityPlaceholder')" />
    </div>

    <!-- Preset "Reduzieren"; Schalter auf "Hinzufuegen" addiert die Menge -->
    <div class="m-wms-switch">
      <button :class="{ 'on--minus': !isAdd }" @click="isAdd = false">− {{ $t("mobile.wms.reduce") }}</button>
      <button :class="{ 'on--plus': isAdd }" @click="isAdd = true">+ {{ $t("mobile.wms.add") }}</button>
    </div>

    <div class="m-wms-actions">
      <button class="m-wms-actions__cancel" @click="$router.push('/m/lager')">{{ $t("mobile.wms.cancel") }}</button>
      <button class="m-wms-actions__save" :disabled="!canSave || saving" @click="save">{{ $t("mobile.wms.save") }}</button>
    </div>

    <m-num-pad v-if="numPadOpen" :title="$t('mobile.wms.quantity')" :initial="quantity" @confirm="quantity = $event" @close="numPadOpen = false" />
  </div>
</template>

<script>
import WarehouseService from "@/services/warehouse.service";
import MNumPad from "../components/MNumPad.vue";
import MWmsInventoryPicker from "./MWmsInventoryPicker.vue";

export default {
  name: "MAnpassung",
  components: { MNumPad, MWmsInventoryPicker },
  props: {
    inventurModus: { type: Boolean, default: false },
  },
  data() {
    return {
      // Feste Werte wie im Desktop-Dialog (Warehouses.vue, Tab "Manuelle Anpassung")
      historyTypes: ["Removal For Spare Parts", "Defect", "Manual Adjustment", "Counting"],
      historyType: "Manual Adjustment",
      reason: this.inventurModus ? this.$t("mobile.wms.countedReason") : "",
      entry: null,
      quantity: null,
      isAdd: false,
      numPadOpen: false,
      saving: false,
    };
  },
  computed: {
    canSave() {
      return !!(this.entry && this.quantity > 0 && this.reason.trim());
    },
  },
  methods: {
    // Gleiche i18n-Schluessel wie der Desktop (wms.statuses.historyTypes.*, snake_case)
    typeLabel(t) {
      return this.$t("wms.statuses.historyTypes." + t.toLowerCase().replace(/ /g, "_"));
    },
    async save() {
      if (!this.canSave || this.saving) return;
      this.saving = true;
      try {
        const res = await WarehouseService.manualAdjustment({
          historyType: this.inventurModus ? "Counting" : this.historyType,
          reason: this.reason.trim(),
          warehouseInventoryId: this.entry.id,
          quantity: this.quantity,
          isAdd: this.isAdd,
        });
        if (res.data && res.data.status === "error") {
          this.$notify({ timeout: 3500, message: this.$t(`wms.messages.${res.data.message}`, res.data.metadata), horizontalAlign: "right", verticalAlign: "top", type: "danger" });
          return;
        }
        this.$notify({ timeout: 2500, message: this.$t("wms.messages.created"), horizontalAlign: "right", verticalAlign: "top", type: "success" });
        this.$router.push("/m/lager");
      } catch (err) {
        this.$notify({ timeout: 3500, message: this.$t("mobile.wms.saveError"), horizontalAlign: "right", verticalAlign: "top", type: "danger" });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./m-wms.scss"></style>
